module.exports = __webpack_public_path__ + "assets/adv.482acad3e43d18749ace05d5a3b0a654.png";